import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import ContentCadastro from '../../layout/content/ContentCadastro';
import Form from '../../layout/form/Form';
import ServiceNav from '../../layout/nav/ServiceNav';
import NavTab from '../../layout/nav/NavTab';
import Aviso from '../../layout/alert/Aviso';
import Sucesso from '../../layout/alert/Sucesso';
import LogoMarca from './LogoMarca';
import Informacao from './Informacao';
import Compartilhada from './Compartilhada';
import Dedicada from './Dedicada';
import Aplicativo from './Aplicativo';
import ConfiguracaoSistema from './ConfiguracaoSistema';
import OpcaoPagamento from './OpcaoPagamento'
import Email from './Email';
import Institucional from './Institucional';

import SistemaService from '../../../service/SistemaService';
import AutenticarService from '../../../service/AutenticarService';

import AplicacaoEnum from '../../../helper/enumerador/AplicacaoEnum';
import PerfilSistemaEnum from '../../../helper/enumerador/PerfilSistemaEnum';
import StatusClienteEnum from '../../../helper/enumerador/StatusClienteEnum';
import FormCodeEnum from '../../../helper/enumerador/FormCodeEnum';


class Sistema extends AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            preload: false,
            
            form: {
                id: 0,                                 
                status: StatusClienteEnum.AGUARDANDO_CONFIGURACAO.name,              
                usuario: this.props.usuario.nome,

                //pagina Informacao
                fantasia: '',
                alias_app: '',
                title: '',
                keywords: '',
                description: '',
                tipo_aplicacao: '',
                perfil_sistema: PerfilSistemaEnum.SHOPPING.name,
                shopping_bag: '',
                logo: '',
                preview: false,

                //Pagina Compartilhada
                endpoint: '',

                //Pagina Dedicada
                dominio: '',
                instalar_subdominio: 0,
                subdominio: '',
                usuario_c_panel: '',
                senha_c_panel: '',
                dbname_c_panel: '',
                dbuser_c_panel: '',
                dbsenha_c_panel: '',

                //Pagina Aplicativo
                token_api: '',
                nome_app: '',
                short_cut: '',
                tema: 0,
                width_logo_empresa_menu_desktop: 90,
                display_logo_empresa_menu_mobile: 0,
                width_logo_empresa_menu_mobile: 47,
                ml_empresa_menu_mobile: -5,
                mt_empresa_menu_mobile: 2,                

                //Email
                email: '',
                senha: '',
                nome_exibicao: '',
                servidor: '',
                porta: '',
                usuario_email: '',
                auth: 1,
                smtp_seguranca: 'SSL' ,

                //Configuracao do Sistema
                configuracao: [],
                
                //Opcao de Pagamento
                opcao_pagamento: [],

                // Institucional
                institucional: {
                    historiaPrincipal : {},
                    historiaSecundaria: [],
                    socialPrincipal: {},
                    social: [],
                    socialGooglePlay: {},
                    carrossel: [],
                    enderecoLoja: [],
                    oferta: {},
                    compre_online: {}
                },
                
                // Valida se usa ou não Institucional
                usa_institucional: ''
            },



            erroForm: {
                //pagina Informacao
                alias_app: '',
                title: '',
                keywords: '',
                description: '',
                tipo_aplicacao: '',
                perfil_sistema: '',
                shopping_bag: '',
                logo: '',

                //Pagina Compartilhada
                endpoint: '',

                //Pagina Dedicada
                dominio: '',
                subdominio: '',
                usuario_c_panel: '',
                senha_c_panel: '',
                dbname_c_panel: '',
                dbuser_c_panel: '',
                dbsenha_c_panel: '',

                //Pagina Aplicativo
                token_api: '',
                nome_app: '',
                short_cut: '',
                tema: '',
                width_logo_empresa_menu_desktop: '',
                display_logo_empresa_menu_mobile: '',
                width_logo_empresa_menu_mobile: '',
                ml_empresa_menu_mobile: '',
                mt_empresa_menu_mobile: '',

                //Email
                email: '',
                senha: '',
                nome_exibicao: '',
                servidor: '',
                porta: '',
                usuario_email: '',
                email_teste:'',
                auth: '',
                smtp_seguranca: '',

                // Institucional
                institucional: {
                    historiaPrincipal : {},
                    historiaSecundaria: [],
                    socialPrincipal: {},
                    social: [],
                    socialGooglePlay: {},
                    carrossel: [],
                    enderecoLoja: [],
                    oferta: {},
                    compre_online: {}
                }
            },

            salvar: {
                disabled: true,
                name: 'Salvar'
            },            
            
            erro: {
                message: '',
                code: 0
            },

            temas: [],            

            sucesso: false,

            alterando: false,

            sucessoTexto: 'Configurações salva com sucesso',

            modalErroMsg: {
                message: '',
                code: 0,
            }
        }  
        
        this.nav = new ServiceNav();
    }    

    onChange(e) {
        var form = this.state.form;
        form[e.target.name] = e.target.value;
        var salvar = this.state.salvar;

        salvar.disabled = false;
        this.setState({
            form: form,
            salvar: salvar
        });
    }

    onRefresh(valor, index) {
        var form = this.state.form;
        var configuracao = form.configuracao;
        var item = configuracao[index];

        item.valor = valor;

        configuracao.splice(index, 1, item);

        form.configuracao = configuracao;

        this.setState({form: form});
    }

    onInstalarSubdominioChange(input) {
        let form = this.state.form;

        if(parseInt(input.target.value, 10) === 1)
            form.subdominio = 'app';
        else
            form.subdominio = '';

        this.setState({form: form});

        this.onChange(input);
    }

    opcaoPagamento(opcaoPagamento, enabledSalvar) {
        let form = this.state.form;

        form.opcao_pagamento = opcaoPagamento;

        var salvar = this.state.salvar;        

        salvar.disabled = enabledSalvar;

        this.setState({
            form: form,
            salvar: salvar
        });
    }

    onChangeInstitucional(institucional, enabledSalvar) {
        let form = this.state.form;

        form.institucional = institucional;

        var salvar = this.state.salvar;        

        salvar.disabled = enabledSalvar;

        console.log('Sistema.js');
        console.log(form);

        this.setState({
            form: form,
            salvar: salvar
        });
    }

    onValidaLogo() {
        var erroForm = this.state.erroForm;
        var el = document.getElementById("erro");
        let preview = true;

        erroForm.logo = '';

        if(el.value !== '') {
            erroForm.logo = el.value;
            preview = false;
        }

        var form = this.state.form;

        form.preview = preview;

        var salvar = this.state.salvar;

        salvar.disabled = false;

        this.setState({
            erroForm: erroForm,
            form: form,
            salvar: salvar
        });
    }

    showPage(index, show) {
        const nav = this.nav.getMenu();
        const menu = nav[index];
        const props = menu.props;

        menu.props.visible = show;
        menu.props = props;

        nav.splice(index, 1, menu);

        this.nav.setMenu(nav);
    }

    criaMenu() {                        
        this.nav.addComponent(
            1,
            'logomarca',
            'Logomarca',
            false,
            LogoMarca,
            {
                usuario: this.props.usuario,
                form: this.state.form,
                erroForm: this.state.erroForm,                
                onChange: (e) => this.onChange(e),
                onValidaLogo: () => this.onValidaLogo()
            }
        );

        this.nav.addComponent(
            2,
            'informacao',
            'Informação',
            false,
            Informacao,
            {
                usuario: this.props.usuario,
                form: this.state.form,
                erroForm: this.state.erroForm,                
                onChange: (e) => this.onChange(e),
                compartilhada: (show) => this.showPage(2, show),
                dedicada: (show) => this.showPage(3, show)                
            }
        );

        this.nav.addComponent(
            3,
            'compartilhada',
            'Compartilhada',
            false,
            Compartilhada,
            {
                usuario: this.props.usuario,
                visible: false,
                form: this.state.form,
                erroForm: this.state.erroForm,                
                onChange: (e) => this.onChange(e)
            }
        );

        this.nav.addComponent(
            4,
            'dedicada',
            'Dedicada',
            false,
            Dedicada,
            {
                usuario: this.props.usuario,
                visible: false,
                form: this.state.form,
                erroForm: this.state.erroForm,                
                onChange: (e) => this.onChange(e),
                onInstalarSubdominioChange: (e) => this.onInstalarSubdominioChange(e),
                onErro: (erro) => this.setState({modalErroMsg: erro})
            }
        );

        this.nav.addComponent(
            5,
            'aplicativo',
            'Aplicativo',
            false,
            Aplicativo,
            {
                usuario: this.props.usuario,                
                form: this.state.form,
                temas: this.state.temas,
                erroForm: this.state.erroForm,                
                onChange: (e) => this.onChange(e)
            }
        );

        this.nav.addComponent(
            6,
            'email',
            'Email',
            false,
            Email,
            {
                usuario: this.props.usuario,
                form: this.state.form,
                salvar: this.state.salvar,
                erroForm: this.state.erroForm,                
                onChange: (e) => this.onChange(e), 
                onErro: (erro) => this.setState({modalErroMsg: erro})
            }
        );

        this.nav.addComponent(
            7,
            'configuracaoSistema',
            'Configuracao do Sistema',
            false,
            ConfiguracaoSistema,
            {      
                usuario: this.props.usuario,          
                form: this.state.form,
                erroForm: this.state.erroForm,                
                onChange: (e) => this.onChange(e),
                onRefresh: (valor, index) => this.onRefresh(valor, index)
            }
        );

        this.nav.addComponent(
            8,
            'opcaoPagamento',
            'Opção de Pagamento',
            false,
            OpcaoPagamento,
            {      
                usuario: this.props.usuario,                        
                form: this.state.form,
                erroForm: this.state.erroForm,                
                onChange: (opcaoPagamento) => this.opcaoPagamento(opcaoPagamento, false),
                onUpdate: (opcaoPagamento) => this.opcaoPagamento(opcaoPagamento, true),
                onRefresh: (valor, index) => this.onRefresh(valor, index)
            }
        ); 

        if(this.state.form.usa_institucional === 'Sim'){
            this.nav.addComponent(
                9,
                'institucional',
                'Institucional',
                false,
                Institucional,
                {
                    usuario: this.props.usuario,
                    form: this.state.form, 
                    erroForm: this.state.erroForm,             
                    onChange: (e) => this.onChangeInstitucional(e, false),
                    onUpdate: (e) => this.onChangeInstitucional(e, true),        
                }
            );
        }

        this.showPage((this.state.form.tipo_aplicacao === AplicacaoEnum.COMPARTILHADA.name ? 2 : 3), true);

        this.setState({preload: false});
    }   

    buscaCliente() {
        this.setState({preload: true});

        SistemaService.buscarById(
            AutenticarService.getIdEmpresa()
        ).then(resposta => {
            let form = this.state.form;            

            form.id = resposta.data.id;
            form.status = resposta.data.status;
            form.token_api = resposta.data.token_api;

            if(resposta.data.status === StatusClienteEnum.AGUARDANDO_CONFIGURACAO.name) {
                this.setState({
                    form: form,
                    alterando: true                    
                });

                this.criaMenu();

                return ;
            }

            //Pagina LogoMarca
            form.logo = resposta.data.logo;
            form.preview = form.logo !== '';

            //Pagina Informacao
            form.alias_app = resposta.data.alias_app;
            form.title = resposta.data.title;
            form.keywords = resposta.data.keywords;
            form.description = resposta.data.description;
            form.fantasia = resposta.data.fantasia;
            form.tipo_aplicacao = resposta.data.tipo_aplicacao.toUpperCase();            

            form.perfil_sistema = resposta.data.perfil_sistema === '' ? PerfilSistemaEnum.SHOPPING.name : resposta.data.perfil_sistema;
            form.shopping_bag = resposta.data.shopping_bag;

            //Pagina Compartilhada
            form.endpoint = resposta.data.endpoint;

            //Pagina Dedicada
            form.dominio = resposta.data.dominio;
            form.instalar_subdominio = resposta.data.instalar_subdominio;
            form.subdominio = resposta.data.subdominio;
            form.usuario_c_panel = resposta.data.usuario_c_panel;
            form.senha_c_panel = resposta.data.senha_c_panel;
            form.dbname_c_panel = resposta.data.db_name_c_panel;
            form.dbuser_c_panel = resposta.data.db_user_c_panel;
            form.dbsenha_c_panel = resposta.data.db_senha_c_panel;

            //Pagina Aplicativo
            form.nome_app = resposta.data.nome_app;
            form.short_cut = resposta.data.short_cut;
            form.tema = resposta.data.id_tema;
            form.width_logo_empresa_menu_desktop = resposta.data.width_logo_empresa_menu_desktop;
            form.width_logo_empresa_menu_mobile = resposta.data.width_logo_empresa_menu_mobile;
            form.display_logo_empresa_menu_mobile = resposta.data.display_logo_empresa_menu_mobile;
            form.ml_empresa_menu_mobile = resposta.data.ml_empresa_menu_mobile;
            form.mt_empresa_menu_mobile = resposta.data.mt_empresa_menu_mobile;

            //Opcao            
            form.configuracao = resposta.data.configuracao; 
            
            //Usa Institucional
            form.usa_institucional = resposta.data.usa_institucional;

            //Email
            if(resposta.data.cliente_conta_email !== undefined) {
                form.email = resposta.data.cliente_conta_email.email;
                form.senha = resposta.data.cliente_conta_email.senha;
                form.nome_exibicao = resposta.data.cliente_conta_email.nome_exibicao;
                form.servidor = resposta.data.cliente_conta_email.servidor;
                form.porta = resposta.data.cliente_conta_email.porta;
                form.usuario_email = resposta.data.cliente_conta_email.usuario;
            }

            this.setState({
                form: form,
                alterando: true                
            });    
            
            this.criaMenu();
        }).catch(erro => {
            this.setState({
                modalErroMsg: this.trataErro(erro),
                preload: false
            });
        });
    }


    componentDidMount() {     
        this.buscaCliente();
    }

    limparErroForm() {
        var erroForm = this.state.erroForm;

        //pagina Informacao
        erroForm.alias_app = '';
        erroForm.title = '';
        erroForm.keywords = '';
        erroForm.description = '';
        erroForm.tipo_aplicacao = '';
        erroForm.perfil_sistema = '';
        erroForm.shopping_bag = '';
        erroForm.logo = '';

        //Pagina Compartilhada
        erroForm.endpoint = '';

        //Pagina Dedicada
        erroForm.dominio = '';
        erroForm.subdomino = '';
        erroForm.usuario_c_panel = '';
        erroForm.senha_c_panel = '';
        erroForm.dbname_c_panel = '';
        erroForm.dbuser_c_panel = '';
        erroForm.dbsenha_c_panel = '';

        //Pagina Aplicativo
        erroForm.nome_app = '';
        erroForm.short_cut = '';
        erroForm.tema = '';
        erroForm.width_logo_empresa_menu_desktop = '';
        erroForm.display_logo_empresa_menu_mobile = '';
        erroForm.width_logo_empresa_menu_mobile = '';
        erroForm.ml_empresa_menu_mobile = '';
        erroForm.mt_empresa_menu_mobile = '';

        //Email
        erroForm.email = '';
        erroForm.senha = '';
        erroForm.nome_exibicao = '';
        erroForm.servidor = '';
        erroForm.porta = '';
        erroForm.usuario_email = '';

        this.setState({
            erroForm: erroForm
        });

        this.nav.clearIndexErro();
    }

    canSave() {
        this.limparErroForm();

        var form = this.state.form;
        var erroForm = this.state.erroForm;
        var erro = false;
        var index0Erro = false;
        var index1Erro = false;
        var index2Erro = false;
        var index3Erro = false;
        var index4Erro = false;
        var index5Erro = false;

        if(!form.preview) {
            erroForm.logo = "Informe a sua Logomarca";
            index0Erro = true;
            erro = true;
        }

        if(!form.alias_app) {
            erroForm.alias_app = 'Informe o campo Alias';
            erro = true;
            index1Erro = true;
        }

        if(!form.title) {
            erroForm.title = 'Informe o campo Title';
            erro = true;
            index1Erro = true;
        }

        if(!form.keywords) {
            erroForm.keywords = 'Informe o campo Keywords';
            erro = true;
            index1Erro = true;
        }

        if(!form.description) {
            erroForm.description = 'Informe o campo Description';
            erro = true;
            index1Erro = true;
        }

        if(!form.tipo_aplicacao) {
            erroForm.tipo_aplicacao = 'Informe o campo Tipo da aplicação';
            erro = true;
            index1Erro = true;
        }

        if(!form.perfil_sistema) {
            erroForm.perfil_sistema = 'Informe o campo Perfil do sistema';
            erro = true;
            index1Erro = true;
        }

        if(!form.shopping_bag) {
            erroForm.shopping_bag = 'Informe o campo Tipo de bagagem';
            erro = true;
            index1Erro = true;
        }

        switch(form.tipo_aplicacao) {
            case AplicacaoEnum.COMPARTILHADA.enumName:
                if(!form.endpoint) {
                    erroForm.endpoint = 'Informe o campo Usuário';
                    erro = true;
                    index2Erro = true;
                }

                break;
            case AplicacaoEnum.DEDICADA.enumName:
                if(!form.dominio) {
                    erroForm.dominio = 'Informe o campo Domínio';
                    erro = true;
                    index3Erro = true;
                }

                if(form.instalar_subdominio === 1) {
                    if(!form.subdominio) {
                        erroForm.subdominio = 'Informe o subdomínio';
                        erro = true;
                        index2Erro = true;
                    }
                }

                if(!form.usuario_c_panel) {
                    erroForm.usuario_c_panel = 'Informe o campo Usuário';
                    erro = true;
                    index3Erro = true;
                }

                const btnSenhaCPanel = document.getElementById('btnSenhaCPanel');

                if((btnSenhaCPanel !== undefined)&&(btnSenhaCPanel !== null)) {
                    if(!form.senha_c_panel) {
                        erroForm.senha_c_panel = 'Informe o campo Senha';
                        erro = true;
                        index3Erro = true;
                    }
                }

                if(!form.dbname_c_panel) {
                    erroForm.dbname_c_panel = 'Informe o campo Banco de Dados';
                    erro = true;
                    index3Erro = true;
                }

                if(!form.dbuser_c_panel) {
                    erroForm.dbuser_c_panel = 'Informe o campo Usuário do Banco de Dados';
                    erro = true;
                    index3Erro = true;
                }

                const btnSenhaDB = document.getElementById('btnSenhaDB');

                if((btnSenhaDB !== undefined)&&(btnSenhaDB !== null)) {
                    if(!form.dbsenha_c_panel) {
                        erroForm.dbsenha_c_panel = 'Informe o campo Senha do Banco de Dados';
                        erro = true;
                        index3Erro = true;
                    }
                }

                break;
            default:
                break;
        }

        if(!form.nome_app) {
            erroForm.nome_app = 'Informe o campo Nome do Aplicativo';
            erro = true;
            index4Erro = true;
        }

        if(!form.short_cut) {
            erroForm.short_cut = 'Informe o campo Nome do Aplicativo Reduzido';
            erro = true;
            index4Erro = true;
        }

        if(form.tema === 0) {
            erroForm.tema = 'Informe o campo Tema';
            erro = true;
            index4Erro = true;
        }

        if(!form.width_logo_empresa_menu_desktop) {
            erroForm.width_logo_empresa_menu_desktop = 'Informe o campo Largura Logo (px)';
            erro = true;
            index4Erro = true;
        }

        if(form.display_logo_empresa_menu_mobile) {
            if(!form.width_logo_empresa_menu_mobile) {
                erroForm.width_logo_empresa_menu_mobile = 'Informe o campo Largura Logo (px)';
                erro = true;
                index4Erro = true;
            }

            if(!form.ml_empresa_menu_mobile) {
                erroForm.ml_empresa_menu_mobile = 'Informe o campo Margem a esquerda (px)';
                erro = true;
                index4Erro = true;
            }

            if(!form.mt_empresa_menu_mobile) {
                erroForm.mt_empresa_menu_mobile = 'Informe o campo Margem ao Topo (px)';
                erro = true;
                index4Erro = true;
            }
        }
        
        if (!form.email) {
            erroForm.email = 'Informe o campo email';
            erro = true;
            index5Erro = true;
        }

        const btnSenhaEmail = document.getElementById('btnSenhaEmail');

        if((btnSenhaEmail !== undefined)&&(btnSenhaEmail !== null)) {
            if (!form.senha) {
                erroForm.senha = 'Informe a senha';
                erro = true;
                index5Erro = true;
            }
        }

        if (!form.nome_exibicao) {
            erroForm.nome_exibicao = 'Informe o nome para a exibição';
            erro = true;
            index5Erro = true;
        }

        if (!form.servidor) {
            erroForm.servidor = 'Informe o servidor para o envio do email';
            erro = true;
            index5Erro = true;
        }

        if (!form.porta) {
            erroForm.porta = 'Informe a porta do envio do email';
            erro = true;
            index5Erro = true;
        }

        if (!form.usuario_email) {
            erroForm.usuario_email = 'Informe o usuário';
            erro = true;
            index5Erro = true;
        }        

        if(erro) {
            if(index0Erro)
                this.nav.setIndexErro(0);

            if(index1Erro)
                this.nav.setIndexErro(1);

            if(index2Erro)
                this.nav.setIndexErro(2);

            if(index3Erro)
                this.nav.setIndexErro(3);

            if(index4Erro)
                this.nav.setIndexErro(4);

            if (index5Erro)
                this.nav.setIndexErro(5);

            this.setState({erroForm: erroForm});

            return false;
        }

        return true;
    }        

    onSubmit(e) {
        if(!this.canSave())
            return ;            

        var salvar = this.state.salvar;

        salvar.disabled = true;
        salvar.name = 'Aguarde...';

        this.setState({
            salvar: salvar,
            erro: {
                message: '',
                code: 0
            }
        });        

        const form = this.state.form;

        form.usuario = this.props.usuario.nome;

        SistemaService.configuracao(
            form
        ).then(() => {
            var salvar = this.state.salvar;

            salvar.name = 'Salvar';

            this.setState({
                salvar: salvar,
                sucesso: true                
            });
        }).catch((erro) => {
            var salvar = this.state.salvar;

            salvar.disabled = false;
            salvar.name = 'Salvar';

            this.setState({
                erro: this.trataErro(erro),
                salvar: salvar
            });
        });
    }

    onUpdateStatus() {
        var form = this.state.form;

        form.status = StatusClienteEnum.AGUARDANDO_INSTALACAO.name;

        this.setState({form: form});
    }

    fecharModal() {
        const msg = this.state.modalErroMsg;

        this.setState({
            modalErroMsg: {
                message: '',
                code: 0
            }
        });

        if(msg.code === FormCodeEnum.SEND_TO_LOGIN)
            this.props.route(this.logout());
    }    

    showStatus() {   
        //return ;

        if(this.state.form.status === StatusClienteEnum.AGUARDANDO_CONFIGURACAO.name) {
            return ;
        }
        
        if(this.state.form.status === StatusClienteEnum.AGUARDANDO_INSTALACAO.name) {
            return (
                <Aviso
                    exibir={true}
                    textoNegrito='Aguardando Instalação.'
                    texto={'O sistema ainda não foi instalado, esse processo pode demorar até 10 minutos.'}                    
                    hasStyle={false}
                    style={{margin: '10px'}}
                />
            );
        }

        return (
            <Sucesso
                exibir={true}
                textoNegrito='Instalado. '
                texto='O seu sistema já está instalado'   
                hasStyle={false}  
                style={{margin: '10px'}}           
            />            
        );
    }

    render() {
        return(                               
            <Form onSubmit={(e) => this.onSubmit(e)} id="form">
                <input type="hidden" name="id" id="id_hiden" defaultValue={this.state.form.id}/>
                <input type="hidden" name="usuario" id="usuario_hiden" defaultValue={this.props.usuario.nome}/>

                {/* Informacao */}
                <input type="hidden" name="alias_app" id="alias_app_hiden" defaultValue={this.state.form.alias_app}/>
                <input type="hidden" name="title" id="title_hiden" defaultValue={this.state.form.title}/>
                <input type="hidden" name="keywords" id="keywords_hiden" defaultValue={this.state.form.keywords}/>
                <input type="hidden" name="description" id="description_hiden" defaultValue={this.state.form.description}/>
                <input type="hidden" name="tipo_aplicacao" id="tipo_aplicacao_hiden" defaultValue={this.state.form.tipo_aplicacao}/>
                <input type="hidden" name="perfil_sistema" id="perfil_sistema_hiden" defaultValue={this.state.form.perfil_sistema}/>
                <input type="hidden" name="shopping_bag" id="shopping_bag_hiden" defaultValue={this.state.form.shopping_bag}/>

                {/* Compartilhada */}
                <input type="hidden" name="endpoint" id="endpoint_hiden" defaultValue={this.state.form.endpoint}/>

                {/* Dedicada */}
                <input type="hidden" name="dominio" id="dominio_hiden" defaultValue={this.state.form.dominio}/>
                <input type="hidden" name="instalar_subdominio" id="instalar_subdominio_hiden" defaultValue={this.state.form.instalar_subdominio}/>
                <input type="hidden" name="subdominio" id="subdominio_hiden" defaultValue={this.state.form.subdominio}/>
                <input type="hidden" name="usuario_c_panel" id="usuario_c_panel_hiden" defaultValue={this.state.form.usuario_c_panel}/>
                <input type="hidden" name="senha_c_panel" id="senha_c_panel_hiden" defaultValue={this.state.form.senha_c_panel}/>
                <input type="hidden" name="dbname_c_panel" id="dbname_c_panel_hiden" defaultValue={this.state.form.dbname_c_panel}/>
                <input type="hidden" name="dbuser_c_panel" id="dbuser_c_panel_hiden" defaultValue={this.state.form.dbuser_c_panel}/>
                <input type="hidden" name="dbsenha_c_panel" id="dbsenha_c_panel_hiden" defaultValue={this.state.form.dbsenha_c_panel}/>

                {/* Aplicativo */}
                <input type="hidden" name="token_api" id="token_api_hiden" defaultValue={this.state.form.token_api}/>
                <input type="hidden" name="nome_app" id="nome_app_hiden" defaultValue={this.state.form.nome_app}/>
                <input type="hidden" name="short_cut" id="short_cut_hiden" defaultValue={this.state.form.short_cut}/>
                <input type="hidden" name="tema" id="tema_hiden" defaultValue={this.state.form.tema}/>
                <input type="hidden" name="width_logo_empresa_menu_mobile" id="width_logo_empresa_menu_mobile_hiden" defaultValue={this.state.form.width_logo_empresa_menu_mobile}/>
                <input type="hidden" name="display_logo_empresa_menu_mobile" id="display_logo_empresa_menu_mobile_hiden" defaultValue={this.state.form.display_logo_empresa_menu_mobile}/>
                <input type="hidden" name="ml_empresa_menu_mobile" id="ml_empresa_menu_mobile_hiden" defaultValue={this.state.form.ml_empresa_menu_mobile}/>
                <input type="hidden" name="mt_empresa_menu_mobile" id="mt_empresa_menu_mobile_hiden" defaultValue={this.state.form.mt_empresa_menu_mobile}/>

                {/* Email */}
                <input type="hidden" name="email" id="email_hiden" defaultValue={this.state.form.email} />
                <input type="hidden" name="senha" id="senha_hiden" defaultValue={this.state.form.senha} />
                <input type="hidden" name="nome_exibicao" id="nome_exibicao_hiden" defaultValue={this.state.form.nome_exibicao} />
                <input type="hidden" name="usuario_email" id="usuario_email_hiden" defaultValue={this.state.form.usuario_email} />
                <input type="hidden" name="porta" id="porta_hiden" defaultValue={this.state.form.porta} />
                <input type="hidden" name="servidor" id="servidor_hiden" defaultValue={this.state.form.servidor} />
                <input type="hidden" name="email_teste" id="email_teste_hiden" defaultValue={this.state.form.email_teste} />
                <input type="hidden" name="auth" id="auth_hiden" defaultValue={this.state.form.auth} />
                <input type="hidden" name="smtp_seguranca" id="smtp_seguranca_hiden" defaultValue={this.state.form.smtp_seguranca} />

                {/* Configuracao do Sistema */}
                <input type="hidden" name="valor_minimo_retirada" id="valor_minimo_retirada_hiden" defaultValue={this.state.form.valor_minimo_retirada} />
                <input type="hidden" name="mensagem_finalizar_pedido" id="mensagem_finalizar_pedido_hiden" defaultValue={this.state.form.mensagem_finalizar_pedido}/>                

                <ContentCadastro
                    title="Configurações do Sistema"
                    history=""

                    preload={this.state.preload}
                    sucesso={this.state.sucesso}
                    textoSucesso={this.state.sucessoTexto}
                    modalErroMsg={this.state.modalErroMsg}

                    salvar={this.state.salvar}
                    erro={this.state.erro}

                    onSalvar="submit"
                    onSucesso={() => this.setState({sucesso: false})}
                    fecharModal={() => this.fecharModal()}

                    // componentFooterCrud={ (props) => { return (
                    //     <ConfiguracaoActionButton 
                    //         id_cliente={this.state.form.id} 
                    //         visible={((this.state.alterando)&&(this.state.form.status === StatusClienteEnum.INSTALADO.name))}                                 
                    //         onReadOnly={false}  
                    //         onUpdateStatus={() => this.onUpdateStatus()}                                                              
                    //         {...props} 
                    //     />
                    // )}}

                    route={(route) => this.props.route(route)}
                >
                    {this.showStatus()}

                    <NavTab
                        nav={this.nav.getMenu()}
                        indexErro={this.nav.getIndexErro()}                        
                    />
                </ContentCadastro>         
            </Form>            
        )
    }
}

export default Sistema;